import React, { useEffect, useRef } from 'react';
import { List, ListItem, ListItemText, Box, Typography } from '@mui/material';
import Markdown from 'react-markdown';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const DEBUG = true;

const styles = {
    ownMessage: {
        backgroundColor: '#dfdfdf',
        textAlign: 'left',
        borderRadius: '10px',
        paddingTop: '0px',
        paddingBottom: '0px',
        paddingLeft: '1em',
        paddingRight: '1em',
        width: '90%'
    },
    systemMessage: {
        backgroundColor: '#ffffff',
        textAlign: 'left',
        borderRadius: '10px',
        paddingTop: '0px',
        paddingBottom: '0px',
        paddingLeft: '1em',
        paddingRight: '1em',
        width: '90%'
    },
};

const AgentMessages = ({ messages }) => {
    if (typeof (messages) === 'string') {
        messages = JSON.parse(messages);
    }

    if (DEBUG) {
        console.log("AgentMessages :: messages", messages);
    }

    return (
        <Box mb={2} mt={4}>
            <Typography variant="body" fontWeight="bold" mb={2}>See on the log below how this conclusion was reached</Typography>
            <Box mt={2}>
                {
                    messages.map((message, index) => (
                        <Accordion key={index}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>{message.source}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Markdown>
                                    {message.content}
                                </Markdown>
                            </AccordionDetails>
                        </Accordion>
                    ))
                }
            </Box>
        </Box>
    );
};

const ChatMessages = ({ messages }) => {
    //const classes = useStyles();
    const messagesEndRef = useRef(null);

    const scrollToBottom = () => {
        const container = messagesEndRef.current?.parentElement?.parentElement; // Get the container element

        if (container) {
            container.scrollTo({
                top: container.scrollHeight,
                behavior: 'smooth',
            });
        }
    };

    useEffect(scrollToBottom, [messages]);

    if (!messages) {
        console.log("ChatMessages :: messages is null");
        return null;
    }

    return (
        <List>
            {messages
                .sort((a, b) => a.created - b.created)
                .map((message, index) => (
                    <div
                        key={index}
                        style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: message.role === 'user' ? 'flex-end' : 'flex-start'
                        }}>
                        <ListItem style={{
                            maxWidth: "100%",
                            justifyContent: message.role === 'user' ? 'flex-end' : 'flex-start',
                            paddingLeft: '5px',
                            paddingRight: '5px',
                        }}>
                            <span style={
                                message.role === 'user'
                                    ? styles.ownMessage
                                    : styles.systemMessage
                            }>
                                <Markdown>
                                    {message.message_content}
                                </Markdown>
                                {
                                    message.agent_messages && message.agent_messages.length > 0 &&
                                    <AgentMessages messages={message.agent_messages} />
                                }
                            </span>
                        </ListItem>
                    </div>
                ))}
            <div ref={messagesEndRef} />
        </List>
    );
};

export default ChatMessages;